export default __webpack_public_path__ + "static/media/number1.223e37fc.svg";